export default "__VITE_ASSET__B9x8JBjq__"